import moment from 'moment'

export function auditDatePeriodFormatter(start_date, end_date) {
  if (end_date !== null && end_date !== '12/31/2100') {
    if (new Date(start_date).getFullYear() === new Date(end_date).getFullYear()) {
      return moment(start_date).format('M/DD') + ' - ' + moment(end_date).format('M/DD/YYYY')
    } else {
      return moment(start_date).format('M/DD/YYYY') + ' - ' + moment(end_date).format('M/DD/YYYY')
    }
  } else {
    return moment(start_date).format('M/DD/YYYY')
  }
}

export function auditFilterFormatter(filter) {
  let field_date = new Date(filter.value_name)
  var hours = field_date.getHours()
  var AmOrPm = hours >= 12 ? 'PM' : 'AM'
  var minutes = String(field_date.getMinutes()).padStart(2, '0')
  hours = hours % 12 || 12
  var dateValue =
    field_date.getMonth() + 1 + '/' + field_date.getDate() + '/' + field_date.getFullYear()
  if (filter.field_type === 'DateField') {
    return `${filter.field_name} (${dateValue})`
  } else if (filter.field_type === 'DateTimeField') {
    return `${filter.field_name} (${dateValue + ' ' + hours + ':' + minutes + ' ' + AmOrPm})  `
  } else if (filter.field_type === 'TimeField') {
    return `${filter.field_name} (${hours + ':' + minutes + ' ' + AmOrPm})`
  } else {
    return `${filter.field_name} (${filter.value_name})`
  }
}

export function getLastAuditPeriod(period) {
  var last_audit_date
  if (period !== null && period !== '') {
    let end_date = period[1] !== null ? period[1] : null
    last_audit_date = auditDatePeriodFormatter(period[0], end_date)
  } else {
    last_audit_date = 'Never'
  }
  return last_audit_date
}

export function getNextAuditPeriod(period) {
  let next_audit_date
  if (period !== null) {
    let end_date = period[1] !== null ? period[1] : null
    next_audit_date = auditDatePeriodFormatter(period[0], end_date)
  } else {
    next_audit_date = 'Not Scheduled'
  }
  return next_audit_date
}
